var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 196.374,
    height: 96.898,
    viewBox: "0 0 196.374 96.898",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "person",
    transform: "translate(3 3.966)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 18.08,
    cy: 18.08,
    rx: 18.08,
    ry: 18.08,
    transform: "translate(21.379)",
    fill: "none",
    stroke: "#cdb273",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M1.5,57.962a39.458,39.458,0,0,1,78.916,0",
    transform: "translate(-1.5 31.97)",
    fill: "none",
    stroke: "#cdb273",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "scissors",
    transform: "translate(193.374 3.966) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x2: 79.824,
    y2: 35.888,
    transform: "translate(0 10.976)",
    fill: "none",
    stroke: "#cdb273",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    y1: 30.235,
    x2: 79.824,
    transform: "translate(0 27.03)",
    fill: "none",
    stroke: "#cdb273",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M13.785,0A13.787,13.787,0,1,1,0,13.785,13.785,13.785,0,0,1,13.785,0Z",
    transform: "translate(62.362 0)",
    fill: "none",
    stroke: "#cdb273",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M13.785,27.573A13.787,13.787,0,1,0,0,13.788,13.785,13.785,0,0,0,13.785,27.573Z",
    transform: "translate(62.362 46.284)",
    fill: "none",
    stroke: "#cdb273",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon);
export default __webpack_public_path__ + "static/media/serviceIcon.9b26368c305bcf0d0703dcd26fe39b4a.svg";
export { ForwardRef as ReactComponent };